import { Button } from '../../components/ui';
import { SectionCard } from '../../components/trainer/SectionCard';

interface QuickActionsProps {
  exerciseCount: number;
  templateCount: number;
  assignmentCount: number;
  sessionCount: number;
  onOpenWorkouts: () => void;
  onOpenClients: () => void;
  onOpenSessions: () => void;
}

export function QuickActions({
  exerciseCount,
  templateCount,
  assignmentCount,
  sessionCount,
  onOpenWorkouts,
  onOpenClients,
  onOpenSessions,
}: QuickActionsProps) {
  return (
    <SectionCard eyebrow="Actions" title="Quick Actions">
      <div className="grid gap-4 lg:grid-cols-[1.4fr_1fr]">
        <div className="grid gap-3 sm:grid-cols-3">
          <Button onClick={onOpenWorkouts} className="justify-start">
            Manage Workouts
          </Button>
          <Button variant="secondary" onClick={onOpenClients} className="justify-start">
            Open Clients
          </Button>
          <Button variant="secondary" onClick={onOpenSessions} className="justify-start">
            Review Sessions
          </Button>
        </div>
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 dark:border-white/10 dark:bg-white/5">
            <p className="text-xs uppercase tracking-wide text-gray-600 dark:text-slate-400">Workout library</p>
            <p className="mt-1 text-sm text-gray-900 dark:text-white">
              {exerciseCount} exercises, {templateCount} templates
            </p>
          </div>
          <div className="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 dark:border-white/10 dark:bg-white/5">
            <p className="text-xs uppercase tracking-wide text-gray-600 dark:text-slate-400">Client activity</p>
            <p className="mt-1 text-sm text-gray-900 dark:text-white">
              {assignmentCount} assignments, {sessionCount} sessions
            </p>
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
